'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = viewConnect;

var _reactRedux = require('react-redux');

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deepMerge(obj, a, b, extra) {
  obj = Object.assign({}, obj);
  for (var key in a) {
    if (Object(a[key]) === a[key] && Object(b[key]) === b[key]) {
      obj[key] = Object.assign({}, a[key], b[key]);
    } else if (b[key] === undefined) {
      obj[key] = a[key];
    } else {
      obj[key] = b[key];
    }
  }
  for (var _key in b) {
    if (obj[_key] === undefined) {
      obj[_key] = b[_key];
    }
  }
  for (var _key2 in extra) {
    obj[_key2] = extra[_key2];
  }
  return obj;
}

/**
 * # 设置视图
 *
 * + bindings绑定的数据和方法，以数据模型名称在props下增加一层属性名，需要把connect的属性合并改为深度合并
 * + context主要生成的react-context
 */
function viewConnect(instance, dispatch) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var getProps = arguments[3];

  function mergeProps(stateProps, dispatchProps, parentProps) {
    var nextProps = void 0;
    if (instance.flattern) {
      nextProps = Object.assign({}, props, stateProps, dispatchProps, parentProps);
    } else {
      nextProps = deepMerge(props, stateProps, dispatchProps, parentProps);
    }
    if (getProps) {
      Object.assign(nextProps, getProps(nextProps));
    }
    nextProps.dispatch = dispatch;
    return nextProps;
  }

  return function (BaseComponent) {
    var mergeStateToProps = void 0;
    var mergeActionToProps = void 0;
    if (typeof instance.dataBindings === 'function') {
      mergeStateToProps = instance.dataBindings;
    } else {
      mergeStateToProps = function mergeStateToProps(state, ownProps) {
        var iState = {};
        for (var key in instance.dataBindings) {
          if (typeof instance.dataBindings[key] === 'function') {
            iState[key] = instance.dataBindings[key].call(instance, state, ownProps);
          } else {
            iState[key] = instance.dataBindings[key];
          }
        }
        return iState;
      };
    }

    if (typeof instance.eventBindings === 'function') {
      mergeActionToProps = instance.eventBindings;
    } else {
      mergeActionToProps = function mergeActionToProps(dispatch) {
        var iActions = {};

        var _loop = function _loop(key) {
          iActions[key] = function () {
            for (var _len = arguments.length, args = Array(_len), _key3 = 0; _key3 < _len; _key3++) {
              args[_key3] = arguments[_key3];
            }

            var result = instance.eventBindings[key].apply(instance, args);
            if (typeof result === 'function') {
              result(dispatch);
            } else {
              dispatch(result);
            }
          };
        };

        for (var key in instance.eventBindings) {
          _loop(key);
        }
        return iActions;
      };
    }

    var Connect = (0, _reactRedux.connect)(mergeStateToProps, mergeActionToProps, mergeProps)(BaseComponent);
    Connect.contextTypes = BaseComponent.contextTypes;
    return (0, _hoistNonReactStatics2.default)(Connect, BaseComponent);
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/base/connect.js
// module id = 71
// module chunks = 0